/* eslint-disable import/order */
import { useState } from 'react'

import { createCustomer } from 'store/customers/actions'
import type { CreateLeanCustomerPayload } from 'store/customers/types'
import { useDispatch } from 'store/hooks'

import { Customer } from 'types'

type UseCustomerMutationsResult = [
  {
    create: (payload: CreateLeanCustomerPayload) => void
  },
  {
    data?: Customer
    isLoading: boolean
    isError: boolean
  }
]

type UseCustomerMutationsOptions = {
  onSuccess?: (data?: any) => void
  onError?: (error?: any) => void
}

type CreateCustomerFields = CreateLeanCustomerPayload

export const useCustomerMutations = (options?: UseCustomerMutationsOptions): UseCustomerMutationsResult => {
  const dispatch = useDispatch()

  const [data, setData] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState(false)

  const create = (payload: CreateCustomerFields) => {
    setIsLoading(true)

    dispatch(
      createCustomer(payload, ({ success, content }: any) => {
        setIsLoading(false)

        if (success) {
          setData(content)

          if (!options) {
            return
          }

          if (options.onSuccess) {
            options.onSuccess(content)
          }
        } else {
          setIsError(true)

          if (!options) {
            return
          }

          if (options.onError) {
            options.onError(content)
          }
        }
      })
    )
  }

  return [{ create }, { data, isLoading, isError }]
}
